/** 数值输入合法性：空值、整数、小数、负号、尾随小数点 */
const NUMBER_INPUT_PATTERN = /^-?(0|[1-9]\d*)(\.\d*)?$|^-?$|^\d+\.$/;

export const isValidNumberInput = (value: string): boolean => {
  return !value || NUMBER_INPUT_PATTERN.test(value);
};

/** tea-component Input 的 value 仅接受 string */
export const toInputDisplayValue = (
  value: string | number | undefined | null,
): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }
  return String(value);
};
